import * as React from "react";
import { ZigProvider } from "@cubos/zig-components";

export function ZigComponentsThemeProvider(props: React.PropsWithChildren<{}>) {
	return <ZigProvider>{props.children}</ZigProvider>;
}
